import React from 'react'

const ViewBarArrowDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M20.5 20.9c-.4-.4-1.2-.4-1.6 0l-3.5 3.5V1.1c0-.6-.5-1.1-1.1-1.1-.8 0-1.3.5-1.3 1.1v23.3l-3.5-3.5c-.4-.4-1.2-.4-1.6 0-.2.2-.3.5-.3.8 0 .3.1.6.3.8l5.5 5.5c.2.2.5.3.8.3.3 0 .6-.1.8-.3l5.5-5.5c.2-.2.3-.5.3-.8 0-.3-.1-.6-.3-.8z" />
  </svg>
)

export default ViewBarArrowDown
